<!-- components/ModalFinca.vue -->
<template>
  <div>
    <!-- Boton para añadir fincas flotante -->
    <v-btn color="primary" @click="openModal" depressed>
      <v-icon left>mdi-plus</v-icon>
      Crear Finca
    </v-btn>

    <!-- Diálogo de modal -->
    <v-dialog v-model="modal" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon class="error--text" @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text max-height="600px" class="pa-0">
          <Finca :modal.sync="modal" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Finca from '../views/RU/Finca.vue'

export default {
  name: 'ModalFinca',
  components: {
    Finca,
  },
  data: () => ({
    modal: false,
  }),
  props: {
  registro: {
    type: Object,
    default: () => ({}),
  },
},
  methods: {
    openModal() {
      this.modal = true
    },
    cerrarModal() {
      this.modal = false
    },
  },
}
</script>
